__turbopack_context__.v({
  "breadcrumbs": "detail-module__xgpVtW__breadcrumbs",
  "button": "detail-module__xgpVtW__button",
  "cardLink": "detail-module__xgpVtW__cardLink",
  "chapter": "detail-module__xgpVtW__chapter",
  "chapters": "detail-module__xgpVtW__chapters",
  "closing": "detail-module__xgpVtW__closing",
  "container": "detail-module__xgpVtW__container",
  "customization": "detail-module__xgpVtW__customization",
  "facts": "detail-module__xgpVtW__facts",
  "guide": "detail-module__xgpVtW__guide",
  "hero": "detail-module__xgpVtW__hero",
  "heroCopy": "detail-module__xgpVtW__heroCopy",
  "intro": "detail-module__xgpVtW__intro",
  "page": "detail-module__xgpVtW__page",
  "prose": "detail-module__xgpVtW__prose",
  "related": "detail-module__xgpVtW__related",
  "relatedCard": "detail-module__xgpVtW__relatedCard",
  "relatedGrid": "detail-module__xgpVtW__relatedGrid",
  "relatedVisual": "detail-module__xgpVtW__relatedVisual",
  "textLink": "detail-module__xgpVtW__textLink",
});
